/**
 * PDV Layout
 * Full-screen layout without sidebar for the Point of Sale interface.
 * The PDV operates in full-screen mode for maximum usability.
 */
import { Outlet } from 'react-router-dom';

export function PdvLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
